import {
  benignModerateColor,
  benignStrongColor,
  benignSupportingColor,
  benignVeryStrongColor,
  pathogenicModerateColor,
  pathogenicStrongColor,
  pathogenicSupportingColor,
  pathogenicVeryStrongColor,
} from "../../../../common/helpers/colors";

export function colorInSilicoCardRuleStrength(ruleWithStrength) {
  if (
    ruleWithStrength.includes("PP3") &&
    ruleWithStrength.includes("Very Strong")
  ) {
    return pathogenicVeryStrongColor;
  }
  if (ruleWithStrength.includes("PP3") && ruleWithStrength.includes("Strong")) {
    return pathogenicStrongColor;
  }
  if (
    ruleWithStrength.includes("PP3") &&
    ruleWithStrength.includes("Moderate")
  ) {
    return pathogenicModerateColor;
  }
  if (
    ruleWithStrength.includes("PP3") &&
    ruleWithStrength.includes("Supporting")
  ) {
    return pathogenicSupportingColor;
  }
  if (
    ruleWithStrength.includes("BP4") &&
    (ruleWithStrength.includes("Very Strong") ||
      ruleWithStrength.includes("Stand Alone"))
  ) {
    return benignVeryStrongColor;
  }
  if (ruleWithStrength.includes("BP4") && ruleWithStrength.includes("Strong")) {
    return benignStrongColor;
  }
  if (
    ruleWithStrength.includes("BP4") &&
    ruleWithStrength.includes("Moderate")
  ) {
    return benignModerateColor;
  }
  if (
    ruleWithStrength.includes("BP4") &&
    ruleWithStrength.includes("Supporting")
  ) {
    return benignSupportingColor;
  }
  return "black";
}
